import React from "react";
import { DRESS_CODES } from "../utils/config";

export default function DressCode() {
  return (
    <section
      style={{
        background: "linear-gradient(158deg,var(--deep) 0%,var(--forest) 100%)",
        padding: "96px 36px",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: "960px", margin: "0 auto" }} className="reveal">
        <div
          className="section-tag"
          style={{
            color: "var(--gold)",
            justifyContent: "center",
            display: "flex",
          }}
        >
          Dress Code
        </div>
        <h2 className="section-title light">
          Dress to <em>Celebrate</em>
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "16px",
            marginTop: "44px",
            textAlign: "left",
          }}
          className="grid-2-mobile"
        >
          {DRESS_CODES.map((c, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,.05)",
                border: ".5px solid rgba(126,207,184,.17)",
                borderRadius: "9px",
                padding: "24px",
                backdropFilter: "blur(8px)",
              }}
            >
              <div
                style={{
                  fontSize: "8px",
                  letterSpacing: ".18em",
                  textTransform: "uppercase",
                  color: "var(--gold)",
                  marginBottom: "3px",
                }}
              >
                {c.date}
              </div>
              <div
                style={{
                  fontFamily: "var(--font-serif)",
                  fontSize: "19px",
                  color: "#fff",
                  marginBottom: "10px",
                }}
              >
                {c.title}
              </div>

              {/* Swatches: images take priority over colors */}
              {c.images?.length > 0 ? (
                <div
                  style={{ display: "flex", gap: "8px", marginBottom: "10px" }}
                >
                  {c.images.map((src, j) => (
                    <div
                      key={j}
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "50%",
                        border: ".5px solid rgba(255,255,255,.25)",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={src}
                        alt={`${c.title} look ${j + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>
                  ))}
                </div>
              ) : c.swatches?.length > 0 ? (
                <div
                  style={{ display: "flex", gap: "6px", marginBottom: "10px" }}
                >
                  {c.swatches.map((s, j) => (
                    <div
                      key={j}
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        background: s,
                        border: ".5px solid rgba(255,255,255,.14)",
                      }}
                    />
                  ))}
                </div>
              ) : null}

              <div
                style={{
                  fontSize: "12px",
                  color: "rgba(255,255,255,.5)",
                  lineHeight: 1.7,
                }}
              >
                {c.note}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
